import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { ICONS, listPrograms, upcomingPrograms } from '../../data/programs';
import '../../styles/components/landing/ProgramsShowcase.css';

const ProgramsShowcase = ({ eyebrow, title, subtitle }) => {
  const live = listPrograms();

  return (
    <section id="programs" className="ls-programs">
      <div className="container">
        <div className="ls-programs__header">
          {eyebrow && <span className="ls-programs__eyebrow">{eyebrow}</span>}
          <h2 className="ls-programs__title">{title}</h2>
          {subtitle && <p className="ls-programs__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-programs__grid">
          {live.map((p, i) => (
            <motion.div
              key={p.slug}
              className="ls-programs__card ls-programs__card--live"
              style={{
                '--card-primary': p.colors.primary,
                '--card-glow': p.colors.glow,
              }}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <span className="ls-programs__status ls-programs__status--live">Disponível</span>
              <h3>{p.name}</h3>
              <p className="ls-programs__tag">{p.tagline}</p>
              <p className="ls-programs__desc">{p.description}</p>
              <Link to={`/${p.slug}`} className="ls-programs__cta">
                <span>Conhecer o {p.name}</span>
                <ArrowRight size={18} />
              </Link>
              <div className="ls-programs__glow" />
            </motion.div>
          ))}

          {upcomingPrograms.map((p, i) => {
            const Icon = ICONS[p.icon] || Clock;
            return (
              <motion.div
                key={p.slug}
                className="ls-programs__card ls-programs__card--soon"
                style={{
                  '--card-primary': p.colors.primary,
                  '--card-glow': p.colors.glow,
                }}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: (live.length + i) * 0.1 }}
              >
                <span className="ls-programs__status ls-programs__status--soon">Em breve</span>
                <div className="ls-programs__icon">
                  <Icon size={22} />
                </div>
                <h3>{p.name}</h3>
                <p className="ls-programs__tag">{p.tagline}</p>
                <p className="ls-programs__desc">{p.description}</p>
                <div className="ls-programs__cta ls-programs__cta--muted">Avise-me no lançamento</div>
                <div className="ls-programs__glow" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramsShowcase;
